/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'

import { TrucksApi } from '../useCreateTruck/api'

const useTrucks = () => {
  const [isAddTruckModalOpen, setIsAddTruckModalOpen] = useState(false)
  const [isEditTruckModalOpen, setIsEditTruckModalOpen] = useState(false)
  const [isViewTruckModalOpen, setIsViewTruckModalOpen] = useState(false)

  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const onAddTruckSuccess = () => {
    notification.success({
      message: t('Truck added successfully'),
    })
    setIsAddTruckModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.TRUCKS)
  }

  const onAddTruckError = () => {
    notification.error({
      message: t('Error adding truck'),
    })
  }

  const { mutate: addTruck, isLoading: addTruckLoading } = useMutation(TrucksApi.createTruck, {
    onSuccess: onAddTruckSuccess,
    onError: onAddTruckError,
  })

  const openEditTruckModal = () => {
    setIsEditTruckModalOpen(true)
  }

  const closeEditTruckModal = () => {
    setIsEditTruckModalOpen(false)
  }

  return {
    addTruck,
    addTruckLoading,
    isAddTruckModalOpen,
    setIsAddTruckModalOpen,
    isEditTruckModalOpen,
    setIsEditTruckModalOpen,
    openEditTruckModal,
    closeEditTruckModal,
    isViewTruckModalOpen,
    setIsViewTruckModalOpen,
  }
}

export { useTrucks }
